module.exports = __webpack_public_path__ + "img/francis-goeltner-king-s-tent-warroom.1ac49353.jpg";